<template>
  <div style="display: flex">
    <div style="font-weight: bold; font-size: 20px">
      <v-icon class="mr-3">mdi-apps</v-icon>
      Apps
    </div>
    <v-spacer />
    <HelpButton mdx-name="AppsConfigure" />
  </div>
  <v-divider class="mt-3" />
  <div class="config-page-body">
    <div style="margin-top: 40px; margin-bottom: 20px">
      <div></div>
      <v-card-subtitle>All Apps</v-card-subtitle>
      <v-divider />
    </div>
    <v-alert
      class="mb-3"
      variant="tonal"
      color="info"
      v-if="Object.keys(deluge.apps).length === 0"
      icon="mdi-information">
      No apps have been installed yet.
    </v-alert>
    <v-card
      v-for="app in deluge.apps"
      :key="app.api_name"
      style="box-shadow: unset !important">
      <div class="installed-apps-card">
        <v-icon>{{ app.icon }}</v-icon>
        <div class="installed-apps-column">
          <v-card-title>
            {{ app.display_name }}
          </v-card-title>
          <v-card-subtitle>{{ app.description }}</v-card-subtitle>
        </div>
      </div>
      <v-card-actions>
        <v-spacer />
        <v-btn
          @click="delete_app(app)"
          variant="flat"
          :loading="loading"
          color="error">
          Uninstall
        </v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>
<script setup>
import { deluge } from '@/stores/deluge.js';
import { $http } from '../../stores/http.js';
import { ref } from 'vue';
import HelpButton from '../Help-Hints/HelpButton.vue';
const loading = ref(false);
async function delete_app(app) {
  loading.value = true;
  try {
    // Use the new uninstall endpoint which properly kills AppManager first
    await $http('DELETE', '/api/uninstall_app?app_name=' + app.api_name);
    loading.value = false;
  } catch (error) {
    console.error('Failed to uninstall app:', error);
    loading.value = false;
  }
}
</script>

<style scoped>
@import './config.css';

.installed-apps-card {
  display: flex;
  flex-direction: row;
  padding: 15px;
}

.installed-apps-card .v-icon {
  font-size: 65px;
  height: 100%;
}

.installed-apps-column {
  display: flex;
  flex-direction: column;
}

.installed-apps-column .v-card-title,
.installed-apps-column .v-card-subtitle {
  display: flex;
  align-items: center;
  height: 50%;
}
</style>
